import { AppDispatch } from "@/store/store";
import { LoaderApi } from "../agent";
import { LoadersActionCreators } from "@/store/action-creators/loadersActions";

export const loadLoadersThunk = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(LoadersActionCreators.setLoading(true));

    const response = await LoaderApi.getAllLoaders();

    if (response?.length) {
      dispatch(LoadersActionCreators.setLoaders(response));
    }
  } catch (error) {
    console.error("Ошибка загрузки лоадеров:", error);
  } finally {
    dispatch(LoadersActionCreators.setLoading(false));
  }
};
